import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../lib/redux/hooks';
import { Layout } from "../../ui/layout";
import { ButtonComponent } from "../../ui/molecules/button/newButton";
import { MadfarmStaticSelect } from "../../ui/molecules/select/newSelect/static";
import { MenuItems } from "../../ui/organisms/navbar/dto";
import { OptionType, status } from "../../utils";
import { GetHeadQuarter, resetGetAllSot } from "../sot/slice";
import { getUsers, setHeadQuarterFilter, setStatusFilter } from "./slice";
import './style.scss';
import { UsersList } from "./usersList";

export function Users() {
    const usersState = useAppSelector(state => state.users)
    const sotState = useAppSelector(state => state.headQuarter)
    const [headquarter, setHeadquarters] = useState<OptionType[]>([])

    useEffect(() => {
        dispatch(getUsers(usersState.filters))
    }, [])

    useEffect(() => {
        dispatch(getUsers(usersState.filters))
    }, [usersState.userCreationStatus])

    useEffect(() => {
        dispatch(GetHeadQuarter(sotState.sotFilters))
    }, [])

    useEffect(() => {
        if (sotState.responseHeadQuarterStatus === 'successfully') {
            if (sotState.responseHeadQuarter) {
                const data = sotState.responseHeadQuarter.data
                const newObjects: OptionType[] = data.map(d => {
                    return { value: d.id, label: `${d.code}` } as OptionType
                })
                setHeadquarters(newObjects)
            }

            dispatch(resetGetAllSot())
        }
    }, [sotState.responseHeadQuarterStatus])

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    return (
        <Layout
            menuItem={MenuItems.USERS}
            breadcrumbItems={['Utenti']}
            headerLabel="Lista Utenti"
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end">
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Nuovo Utente"
                        color={"orange"}
                        onClick={() => {
                            navigate('/user')
                        }}
                    />
                </div>
            }
        >
            <div className="flex flex-col gap-2" style={{ maxHeight: 'calc(100% - 56px)' }}>
                <div className="w-1/2 flex items-center gap-2">
                    <MadfarmStaticSelect
                        isClearable
                        options={headquarter}
                        placeholder={"Sede"}
                        value={usersState.filters.headquarterId ?? null}
                        noOptionsMessage={"Nessuna sede trovata"}
                        onChange={(value) => {
                            // @ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setHeadQuarterFilter(newValue))
                        }}
                    />
                    <MadfarmStaticSelect
                        isClearable
                        placeholder={'Stato'}
                        options={status}
                        value={usersState.filters.active === true ? "active" : usersState.filters.active === false ? "inactive" : null}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(
                                setStatusFilter(newValue)
                            );
                        }}
                        noOptionsMessage={""}
                    />
                    <div className={"flex flex-row gap-2 items-center"}>
                        <ButtonComponent
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"outline"}
                            color={"gray"}
                            label="Pulisci"
                            onClick={() => {
                                dispatch(setHeadQuarterFilter(null));
                                dispatch(setStatusFilter(null))
                            }}
                        />
                        <ButtonComponent
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"outline"}
                            color={"orange"}
                            label="Cerca"
                            onClick={() =>
                                dispatch(getUsers(usersState.filters))
                            }
                        />
                    </div>
                </div>
                <UsersList />
            </div>
        </Layout>
    )
}